// Professional Services Configuration
// This file centralizes all professional service type configurations
// To add new service types, simply add them to this configuration

export const PROFESSIONAL_SERVICES = {
  ATTORNEY: {
    value: 'attorney',
    label: 'Attorney',
    role: 3,
    licenseField: {
      name: 'barNumber',
      label: 'Bar Number',
      placeholder: 'Bar Number',
      validationMessage: 'Bar Number is required'
    }
  },
  FIDUCIARY: {
    value: 'fiduciary',
    label: 'Fiduciary',
    role: 6,
    licenseField: {
      name: 'barNumber', // Using same field name for consistency
      label: 'License Number',
      placeholder: 'License Number',
      validationMessage: 'License Number is required'
    }
  }
};

// Helper functions for working with professional services
export const getServiceByRole = (role) => {
  return Object.values(PROFESSIONAL_SERVICES).find(service => service.role === role);
};

export const getServiceByValue = (value) => {
  return PROFESSIONAL_SERVICES[value.toUpperCase()];
};

export const getAllServices = () => {
  return Object.values(PROFESSIONAL_SERVICES);
};

export const getServiceOptions = () => {
  return getAllServices().map(service => ({
    value: service.value,
    label: service.label
  }));
};

// Get license field configuration based on role or service type
export const getLicenseFieldConfig = (role, serviceType = null) => {
  // First try to get by service type if provided
  if (serviceType) {
    const service = getServiceByValue(serviceType);
    if (service) return service.licenseField;
  }

  // Fallback to role-based lookup
  const service = getServiceByRole(role);
  return service ? service.licenseField : PROFESSIONAL_SERVICES.ATTORNEY.licenseField;
};

// Get validation message for license field
export const getLicenseValidationMessage = (role, serviceType = null) => {
  const config = getLicenseFieldConfig(role, serviceType);
  return config.validationMessage;
};
